/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `CardType*`'s.
 */
export type CardType = CardTypeInfo | CardTypeDanger | CardTypeSuccess;

/**
 * The Card info type.
 */
export type CardTypeInfo = typeof CARD_TYPE_INFO;

/**
 * The Card danger type.
 */
export type CardTypeDanger = typeof CARD_TYPE_DANGER;

/**
 * The Card success type.
 */
export type CardTypeSuccess = typeof CARD_TYPE_SUCCESS;

/**
 * The Card info constant.
 */
export const CARD_TYPE_INFO = `info`;

/**
 * The Card danger constant.
 */
export const CARD_TYPE_DANGER = `danger`;

/**
 * The Card success constant.
 */
export const CARD_TYPE_SUCCESS = `success`;
